import { UserType } from "src/common/enums";

export function isEmptyString(str: string | null | undefined): boolean {
    return !str || str.length === 0;
}

export function isPrimaryAdminRole(role: string): boolean {
    return role === UserType.ABBM_PRIMARY || role === UserType.USER_ADMIN_PRIMARY;
}

/**
 * Returns a copy of `set` with `member` removed if present, added if not. A new Set is returned
 * (never a mutation) so the result is usable directly in a React state updater.
 *
 * @param set the current set.
 * @param member the member to toggle.
 * @return a new set with the membership flipped.
 */
export function toggleSetMember<T>(set: ReadonlySet<T>, member: T): Set<T> {
    const next = new Set(set);
    if (next.has(member)) {
        next.delete(member);
    } else {
        next.add(member);
    }
    return next;
}

/**
 * Splits a list into consecutive chunks of at most `size`, preserving order.
 *
 * @param items the list to split.
 * @param size the maximum chunk length; must be at least 1.
 * @return the chunks, in order; empty for an empty list.
 * @throws RangeError on a `size` below 1 — no chunking can make progress, so the caller has
 *         misconfigured the call; failing fast beats guessing at a recovery.
 */
export function chunk<T>(items: T[], size: number): T[][] {
    if (size < 1) {
        throw new RangeError(`chunk size must be at least 1, got ${size}`);
    }
    const chunks: T[][] = [];
    for (let i = 0; i < items.length; i += size) {
        chunks.push(items.slice(i, i + size));
    }
    return chunks;
}
